import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';

if (typeof window !== 'undefined' && window.ResizeObserver) {
    const ResizeObserverOriginal = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserverPatched extends ResizeObserverOriginal {
        constructor(callback) {
            super((entries, observer) => {
                window.requestAnimationFrame(() => {
                    callback(entries, observer);
                });
            });
        }
    };
}

const suppressResizeObserverLoopError = (event) => {
    const message = event?.message || '';
    if (message.includes('ResizeObserver loop')) {
        event.stopImmediatePropagation();
        event.preventDefault();
    }
};

window.addEventListener('error', suppressResizeObserverLoopError, true);

const originalConsoleError = console.error;
console.error = (...args) => {
    const firstArg = args[0];
    const message = typeof firstArg === 'string' ? firstArg : firstArg?.message || '';
    if (message.includes('ResizeObserver loop')) {
        return;
    }
    originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wrap the render in a setTimeout to ensure DOM is ready
setTimeout(() => {
  root.render(
    <React.StrictMode>
      <CssVarsProvider disableTransitionOnChange>
        <CssBaseline />
        <App />
      </CssVarsProvider>
    </React.StrictMode>
  );
}, 0);
